export const GET_EMPLOYER_DOCUMENTS_BY_ID = 'GET_EMPLOYER_DOCUMENTS_BY_ID';
export const GET_EMPLOYER_DOCUMENTS_BY_ID_SUCCESS = 'GET_EMPLOYER_DOCUMENTS_BY_ID_SUCCESS';
export const GET_EMPLOYER_DOCUMENTS_BY_QUERY = 'GET_EMPLOYER_DOCUMENTS_BY_QUERY';
export const GET_EMPLOYER_DOCUMENTS_BY_QUERY_SUCCESS = 'GET_EMPLOYER_DOCUMENTS_BY_QUERY_SUCCESS';
export const UPLOAD_EMPLOYER_DOCUMENTS = 'UPLOAD_EMPLOYER_DOCUMENTS';
export const EDIT_EMPLOYER_DOCUMENTS = 'EDIT_EMPLOYER_DOCUMENTS';
export const DELETE_EMPLOYER_DOCUMENTS = 'DELETE_EMPLOYER_DOCUMENTS';
export const EMPLOYER_DOCUMENT_ERROR = 'EMPLOYER_DOCUMENT_ERROR';
